import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "dollar.icon",
  "use": "dollar.icon-usage",
  "viewBox": "-14126 -16067 22 23",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-14126 -16067 22 23\" id=\"dollar.icon\"><g data-name=\"Group 58\" fill=\"currentColor\"><path data-name=\"Subtraction 5\" d=\"M11,22A11,11,0,0,1,3.222,3.222,11,11,0,1,1,18.778,18.778,10.928,10.928,0,0,1,11,22ZM11,2a9,9,0,1,0,9,9A9.01,9.01,0,0,0,11,2Z\" transform=\"translate(-14126 -16066)\" /><text data-name=\"$\" transform=\"translate(-14120 -16049)\" font-size=\"17\" font-family=\"SegoeUI,Segoe UI\"><tspan x=\"0\" y=\"0\">$</tspan></text></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/dollar.icon.svg
// module id = ExBe
// module chunks = 13